import { render } from "./SurveyDrawer.vue?vue&type=template&id=24d61cca&lang=pug"
import script from "./SurveyDrawer.vue?vue&type=script&lang=js"
export * from "./SurveyDrawer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__